import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const awardMembershipApi = generateNomenApi(`/award/award-membership`);

export const awardMembershipOptions = generateNomenOptions('award-membership', awardMembershipApi);
